export const links = [
  {
    url: "https://github.com/srikarsunchu",
    display: "GitHub",
  },
  {
    url: "https://www.linkedin.com/in/srikar-sunchu-651314220/",
    display: "LinkedIn",
  },
  {
    url: "https://www.srikarsunchu.com",
    display: "Portfolio",
  },
];
